export default class DOMObserver {
  constructor() {
    const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

    this.watch = ($element, callback) => {
      if (MutationObserver) {
        const mutationObserver = new MutationObserver(callback);
        mutationObserver.observe($element, {
          childList: true,
          subtree: true,
        });
        return mutationObserver;
      }
      // Fallback when no mutation observer exists
      $element.addEventListener('DOMNodeInserted', callback, false);
      $element.addEventListener('DOMNodeRemoved', callback, false);

      return null;
    };
  }
}
